import { RegisteredSecurityStock } from "../../../../../core/models/configuration-system";
import { DataTable } from "../../data-table.interface";
const iconsOfActionsList = [
  {
    icon: 'edit',
    tooltip: 'editar',
    hasVisibleCondition: (element: RegisteredSecurityStock[]): boolean => element.length >= 1
  },
  {
    icon: "trash",
    tooltip: "Eliminar",
  }
];

export const securityStockCes: DataTable = {
    searchText: 'Buscar entidad',
    addText: 'Crear stock de seguridad',
    export: false,
    filter: false,
    dialogHability: false,
    filterDefault: 'TD',
    disabled: false,
    partialField: '',
    checkbox: true,
    checkboxHeader: false,
    iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (row: RegisteredSecurityStock, selection: RegisteredSecurityStock[]) => {
      if (selection && selection.length > 0 && row && selection[0].id) {
        return selection.length === 1 && row.id === selection[0].id && selection[0].entitySecurityStock!=null? false : true;
      } else {
        return row.id? false: true;
      }
    },
    columns: [
      {
        title: 'Entidad',
        name: 'entityName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => element.entityName
      },
      {
        title: 'Stock de seguridad',
        name: 'quantity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => element.entitySecurityStock
      },
      {
        title: 'Division',
        name: 'DIVISION',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => {
          return {
            data: element.id,
            icon: 'low_priority',
            tooltip: 'Ver más',
            class: 'recordColumn icon-table'
          };
        }
      },
      {
        title: 'Area',
        name: 'AREA',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => {
          return {
            data: element.id,
            icon: 'low_priority',
            tooltip: 'Ver más',
            class: 'recordColumn icon-table'
          };
        }
      },
      {
        title: 'Departamento',
        name: 'DEPARTAMENTO',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => {
          return {
            data: element.id,
            icon: 'low_priority',
            tooltip: 'Ver más',
            class: 'recordColumn icon-table'
          };
        }
      },
      {
        title: 'Linea',
        name: 'LINEA',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: any) => {
          return {
            data: element.id,
            icon: 'low_priority',
            tooltip: 'Ver más',
            class: 'recordColumn icon-table'
          };
        }
      },
    ]
  };
